<template>
    <div style="background:#fff; margin-top:5px;margin-left:3px; "> 
        <div style="display:flex;background:#EBEEF5;line-height:35px;" >
            <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium" style="width:250px;" ></el-input> 
            <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:15px;"></i>
            <el-link   @click="addRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">新增</span></el-link>
            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
            <el-link   @click="editRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">编辑</span></el-link>
            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
            <el-link   @click="delRec" :underline="false" ><span style="font-size:12px;margin-right:15px;">删除</span></el-link> 
        </div>
        <el-tree :data="accData" 
                    :props="defaultProps" 
                    @node-click="handleNodeClick" 
                    node-key="id"                       
                    :style="{height: scrollerHeight,overflow:'auto',display: 'flex',padding:15}"
                    highlight-current
                    :filter-node-method="filterNode"
                    ref="eltree"
                    default-expand-all
                    :expand-on-click-node="false">
            <template v-slot="{node,data}">                                     
                <span v-if="data.id ==0 "  class="nodeRoot" >
                    <i class="iconfont  icon-mokuai1" style="color:#409eff;font-size:16px;margin-right:5px;"></i>
                    <span class="nodeLabel" style="font-size:14px;font-weight:600;color:#409efe">{{ node.label}} </span>
                </span>                  
                <span v-else > 
                    <i class="iconfont icon-fenzhijiedian" style="color:#409eff;font-size:14px;margin-right:5px;"></i><span class="nodeLabel">{{ node.label}} 【{{data.id}} 】 </span>
                </span>
            </template>
        </el-tree>
 
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promptWin" v-dialogDrag width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增框 -->
        <el-dialog  :visible.sync="addWin" v-dialogDrag width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div>
            <div style="line-height:60px;display:flex">
               <div style="float:right;width:100px;"> 上级类别</div>
               <el-select v-model="parentno" size="small" placeholder="请选择" filterable  style="width:300px; " >
                    <span v-for="(item,index) in nodeArr" :key='index'>
                        <el-option :label="item.CNAME" :value="item.CODE" ></el-option>
                    </span>
                </el-select>
            </div>
            <div style="line-height:60px;display:flex">
                <div style="float:right;width:100px;">类别名称<span style="color:red">*</span></div>
                <el-input v-model="subcname" size="small"  style="width:300px;"></el-input>
            </div>
            <div style="line-height:60px;display:flex">
                <div style="float:right;width:100px;">类别编码<span style="color:red">*</span></div>
                <el-input v-model="subcode" disabled size="small" style="width:300px;"></el-input>
            </div>
            <div style="line-height:60px;display:flex">
                <div style="float:right;width:100px;">排序码</div>
                <el-input v-model="sortby" v-enter-number size="small" style="width:300px;"></el-input>
            </div>
            <div style="line-height:60px;color:red">提示：类别编码自动生成 </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="addWin = false" style="margin-right:20px;">取 消</el-button>
                <el-button type="primary" size="small" @click="saveRec">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>

import {getBaseData } from '../../api/user'  
export default {
    props:{
        v_type:{
            type:String,
            default:'PRD',
        }  
    },
    data () {
        return {
            oper:'like',
            subcname:'',
            subcode:'',
 
            lastName:'',
            sortby:'',
            addWin:false,
            addFlag:'create',
            nodeLabel:'产品类别',
            treeid:'0',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            textparam:'', // input 绑定值
            filterText:'',
            accData:[] ,// 
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'',
                idseq:'idseq',
                label: 'label'
            },
            disabled:false,
            parentno:'',
            promptWin:false,
            prompt:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
            nodeArr:[],
        }
    },
    created () {
        if (this.v_username){
  
            this.getTree( '') //初始查询表数据   
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    mounted () {   
       getBaseData(this.v_formurl+'','corpid',this.v_corpid,'ty','PRD','v_bs_TYPE',' order by code').then(res=>{
            this.nodeArr =res.result
        })
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -140
        },
        scrollerHeight: function() {
            return (window.innerHeight - 140) + 'px';
        }, 
    },
    methods: { 
        //删除记录
        delRec(){
            if (this.treeid==='0'){
                this.promptWin=true
                this.prompt='根结点不能删除'
            }else{
            this.$confirm('你确定要删除此节点吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                //发起删除请求
                var vm=this;
                //选判断有没子节点
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'parentno',p_value:this.treeid,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_bs_type'},
                }).then(res=>{  
                    if (res.result.length===0){
                        //判断有没产品引用此类型
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/getBaseData',
                            data: {p_key:'matty',p_value:this.treeid,p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_bs_mat'},
                        }).then(res=>{  
                            if (res.result.length===0){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'code',p_value:this.treeid,p_table:'bs_type'},
                                }).then(res=>{      
                                    if(res.code =='200')  {           
                                        vm.getTree()   
                                        vm.treeid='0'
                                        vm.nodeLabel='产品类别'  
                                        this.$emit('child-close' )
                                    }else{
                                        this.promptWin=true
                                        this.prompt=res.result
                                    }        
                                }) 
                            }else{
                                this.promptWin=true
                                this.prompt='此产品类别下已存在产品,如确要删除此类别请先把相关产品删除'
                            }
                        })
                    }else{
                        this.promptWin=true
                        this.prompt='存在子记录,不能删除'
                    }
                })      
            }).catch(()=>{})
            }
        },
        //保存
        saveRec(){
            if(!this.subcname){
                this.promptWin=true
                this.prompt='类别名称不能为空'
            }else if (!this.subcode){
               this.promptWin=true
               this.prompt='类别编码不能为空' 
            }else if (this.subcode==this.parentno){
               this.promptWin=true
               this.prompt='类别编码与上级类别不能相同' 
            }else{
                var obj_={'CORPID':this.v_corpid,'CODE':this.subcode,'CNAME':this.subcname,'PARENTNO':this.parentno,'SORTBY':this.sortby,'TY':'PRD'}
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(obj_), p_table:'BS_TYPE',p_frmid:''},
                }).then(res=>{    
                    if(res.code ==='200')  {     
                        this.addWin=false   
                        this.getTree()     
                        this.$emit('child-close' ) 
                    }else{
                        this.prompt=res.result
                        this.promptWin=true
                    }        
                }) 
            }
        },
        //编辑
        editRec(){
            this.addFlag='edit'
            if (this.treeid==='0'){
                this.promptWin=true
                this.prompt='根结点不能编辑' 
            }else{
                this.addWin=true
                this.subcode=this.treeid
 
                this.subcname=this.nodeLabel
                this.sortby='' 
                this.parentno=this.parentid
            }
        },
        //新增 
        addRec(){
            this.$axios({ //取到最大IDNO +1
                method: 'post',
                url:'xuper_auth/getMaxNum',
                data: {p_key:'CODE',p_value:"1001" , p_table:'BS_TYPE'},
            }).then(res=>{      
                if(res.code =='200')  {  
                    this.addWin =true
                    this.addFlag ='create'
                    this.subcode=res.result
 
                    this.subcname=''
                    this.sortby='' 
                    this.parentno=this.treeid
                }else{
                    this.prompt=res.result
                    this.promptWin=true
                }        
            })
        },
 
        getTree() {   
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'v_BS_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\' and ty=\'PRD\''}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.accData =res.result;  
                    vm.$nextTick(()=>{ //必须要放在nexttick里，要不然还未渲染上
                        vm.$refs.eltree.setCurrentKey(vm.treeid)
                    })
                } else{
                    vm.promptWin=true
                    vm.prompt=res.result
                }            
            })                            
        },
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1;
        },
        //节点点击
        handleNodeClick(data){
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.parentid=data.parentid
            this.lastName=data.icon
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
     .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
